import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import defaultInstance from '../../axiosHelper';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import CustomHeader from '../header';

// Register components
ChartJS.register(
    BarElement,
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);
const DiseaseWiseScreening = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const apiEndsPoints = state?.api_url
    const pageTitle = state?.page_title

    const [diseaseData, setDiseaseData] = useState();
    const [isLoading, setIsLoading] = useState(true);

    const fetchCounts = async () => {
        const params = {}
        try {
            setIsLoading(true)
            const { data } = await defaultInstance.get(apiEndsPoints, { params });
            setDiseaseData(data?.result)
            setIsLoading(false)
            if (data?.success) {
            }
        } catch (error) {
            setIsLoading(false)
            console.error('Error fetching counts:', error);
        }
    };

    useEffect(() => {
        fetchCounts();
    }, []);

    if (isLoading) {
        return (<div style={{ width: '98vw', height: '95vh', position: 'absolute', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
            <img style={{ width: 50, height: 50 }} src='./loading.gif' alt='loading' />
        </div>)
    }

    const labels = diseaseData.map(item => item.district_name);

    const yesOnTreatmentData = diseaseData?.map(item => (item.yes_on_treatment) || null);

    const notOnTreatmentData = diseaseData?.map(item => (item.not_on_treatment) || null);

    const suspectedData = diseaseData?.map(item => (item.suspected) || null);

    const data = {
        labels,
        datasets: [
            {
                label: 'On Treatment',
                data: yesOnTreatmentData,
                backgroundColor: 'rgba(75, 192, 192, 0.8)',
                borderWidth: 1,
                minBarLength: 35
            },
            {
                label: 'Not On Treatment',
                data: notOnTreatmentData,
                backgroundColor: 'rgba(255, 206, 86, 0.8)',
                borderWidth: 1,
                minBarLength: 35
            },
            {
                label: 'Suspected',
                data: suspectedData,
                backgroundColor: 'rgba(255, 99, 132, 0.8)',
                borderWidth: 1,
                minBarLength: 35
            },
        ],
    };

    console.log(yesOnTreatmentData, notOnTreatmentData, suspectedData, 'suspectedData')

    const options = {
        responsive: true,
        plugins: {
            legend: { display: true },
            title: {
                display: false,
                text: pageTitle,
            },
            datalabels: {
                anchor: 'end',
                align: 'start',
                rotation: -45,
                color: '#333',
                font: {
                    weight: '700',
                },
                offset: -4,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    color: '#000',
                    font: { size: 14, weight: 'bold' },
                },
                title: {
                    display: true,
                    text: 'Count',
                    color: '#000',
                    font: { size: 16, weight: 'bold' },
                },
            },
            x: {
                ticks: {
                    color: '#000',
                    font: { size: 14, weight: 'bold' },
                },
                title: {
                    display: true,
                    color: '#000',
                    font: { size: 16, weight: 'bold' },
                },
            },
        },
    };

    return (
        <div className="role-container">
            {/* Header Section */}
            <CustomHeader heading={pageTitle} />
            <div style={{ marginTop: 50 }}>
                <Bar data={data} options={options} />
            </div>
        </div>
    )
}

export default DiseaseWiseScreening
